<div [ngClass]="{'tk-border-blue': isSelected, 'tk-border-gray-5': !isSelected}"
     class="flex px-4 py-2 rounded-lg cursor-pointer">

  <div class="mt-1.5 w-2 h-2"
       [ngClass]="{'tk-i-arrow-blue-right': !item?.isReturn, 'tk-i-arrow-gray-left': item?.isReturn}"></div>

  <div class="ml-2 flex flex-col">
    <div class="font-semibold text-sm">
      {{(item?.isReturn ? 'handover.status-return' : 'handover.status-given') | translate}}
    </div>
    <div class="tk-c-gray">{{item?.date | date: 'short'}}</div>
  </div>

  <div class="grow flex items-center justify-end">

    <div class="grid place-items-center w-6 h-6 rounded-full text-center text-2xs tk-bg-gray-9-alpha-10">
      <span class="font-semibold tk-c-blue">{{item?.initials}}</span>
    </div>

    <div class="ml-3">{{item?.driverFullName}}</div>
  </div>

</div>
